export const GET_AVAILABLE_CONTACTS_FOR_LOYALTY_APP = "GET_AVAILABLE_CONTACTS_FOR_LOYALTY_APP";
export const SET_AVAILABLE_CONTACTS_FOR_LOYALTY_APP = "SET_AVAILABLE_CONTACTS_FOR_LOYALTY_APP";
export const POST_LOYALTY_USER = "POST_LOYALTY_USER";
export const SET_AVAILABLE_CONTACTS_ORDER = "SET_AVAILABLE_CONTACTS_ORDER";
export const GET_LOYALTY_APP_CONTACTS = "GET_LOYALTY_APP_CONTACTS";
export const SET_LOYALTY_APP_CONTACTS = "SET_LOYALTY_APP_CONTACTS";
export const SET_CONTACTS_IN_LOYALTY_APP_ORDER = "SET_CONTACTS_IN_LOYALTY_APP_ORDER";
